import KunLoading6 from './src/index'

KunLoading6.install = function (Vue){
	Vue.component(KunLoading6.name, KunLoading6);
}

export default KunLoading6;
